'use strict';

module.exports = '3.22.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 858
// module chunks = 1